export const games = [
  {
    id: 1,
    title: "Shadow Realm: Origins",
    genre: "Mobile RPG",
    platform: "iOS / Android",
    players: "80K+",
    status: "Live",
    desc: "A dark fantasy mobile RPG where players forge alliances, battle ancient evils, and conquer mythical realms in real-time PvP.",
    image: "https://public.readdy.ai/ai/img_res/c1be87ec90e5cb294fc366656bebda14.jpg",
    tags: ["RPG", "PvP", "Guild Wars"],
  },
  {
    id: 2,
    title: "Neon Drift",
    genre: "PC Racing",
    platform: "PC / Web",
    players: "45K+",
    status: "Live",
    desc: "A high-octane neon racing game set in a cyberpunk city. Compete online, customize your ride, and climb global leaderboards.",
    image: "https://readdy.ai/api/search-image?query=cyberpunk%20neon%20city%20racing%20game%20art%20futuristic%20cars%20glowing%20streets%20high%20speed%20action%20neon%20green%20amber%20lights%20dark%20night%20city&width=600&height=380&seq=g2&orientation=landscape",
    tags: ["Racing", "Multiplayer", "Leaderboard"],
  },
  {
    id: 3,
    title: "CryptoForge",
    genre: "Web3 Strategy",
    platform: "Web3 / Browser",
    players: "30K+",
    status: "Live",
    desc: "A blockchain strategy game where every asset is player-owned. Build, trade, and battle with true digital ownership.",
    image: "https://readdy.ai/api/search-image?query=blockchain%20web3%20strategy%20game%20art%20digital%20assets%20NFT%20fantasy%20world%20glowing%20runes%20dark%20background%20futuristic%20mystical%20atmosphere&width=600&height=380&seq=g3&orientation=landscape",
    tags: ["Web3", "NFT", "Strategy"],
  },
  {
    id: 4,
    title: "Apex Conquest",
    genre: "Mobile Battle Royale",
    platform: "iOS / Android",
    players: "Coming Soon",
    status: "Beta",
    desc: "A next-gen mobile battle royale with squad mechanics, dynamic maps, and seamless guild integration for organized team play.",
    image: "https://readdy.ai/api/search-image?query=mobile%20battle%20royale%20game%20art%20futuristic%20soldiers%20dark%20battlefield%20dramatic%20lighting%20cinematic%20action%20scene%20neon%20dark%20atmosphere%20military%20sci-fi&width=600&height=380&seq=g4&orientation=landscape",
    tags: ["Battle Royale", "Squad", "Mobile"],
  },
];

export const guilds = [
  {
    name: "Shadow Legion",
    game: "Shadow Realm: Origins",
    members: 120,
    rank: "#1 Malaysia",
    icon: "ri-skull-line",
    color: "#00ff88",
  },
  {
    name: "Neon Racers Club",
    game: "Neon Drift",
    members: 85,
    rank: "#3 SEA",
    icon: "ri-speed-line",
    color: "#f59e0b",
  },
  {
    name: "Forge Alliance",
    game: "CryptoForge",
    members: 64,
    rank: "#2 Global",
    icon: "ri-sword-line",
    color: "#00ff88",
  },
  {
    name: "Apex Wolves",
    game: "Apex Conquest",
    members: 45,
    rank: "Beta Top 5",
    icon: "ri-shield-star-line",
    color: "#f59e0b",
  },
];

export const guildPerks = [
  { icon: "ri-trophy-line", title: "Exclusive Tournaments", desc: "Guild-only tournaments with real cash prizes and exclusive in-game rewards." },
  { icon: "ri-coins-line", title: "Shared Economy", desc: "Internal guild treasury, shared resources, and collaborative in-game economies." },
  { icon: "ri-user-add-line", title: "Smart Recruitment", desc: "AI-powered player matching to find the perfect members for your guild's playstyle." },
  { icon: "ri-bar-chart-line", title: "Performance Analytics", desc: "Detailed stats, heatmaps, and coaching insights to help your guild improve." },
  { icon: "ri-calendar-event-line", title: "Event Management", desc: "Full-suite tools to schedule, coordinate, and broadcast guild events and raids." },
  { icon: "ri-global-line", title: "Cross-game Support", desc: "One guild hub for all your games — manage your community across multiple titles." },
];
